import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col" }

import PatientSearch from '@/views/mainMenu/patientSearch.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esSearchPatientModal',
  props: {
  fastPatientCreation: {
    type: Boolean,
    default: false,
  }
},
  emits: ["modal-close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PatientSearch, {
      class: "es-patient-search mtop-08",
      "fast-patient-creation": props.fastPatientCreation,
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (emit('modal-close')))
    }, null, 8, ["fast-patient-creation"])
  ]))
}
}

})